var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawObservationsReOhja1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 755,
    height: 960,
    viewBox: "0 0 755 960",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_observations_re_ohja 1",
    opacity: 0.4,
    clipPath: "url(#clip0_96_2053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M399.527 562.749L111.086 608.326L111.568 611.375L400.009 565.797L399.527 562.749Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M402.899 584.089L114.458 629.666L114.939 632.714L403.381 587.137L402.899 584.089Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M406.271 605.428L117.83 651.006L118.311 654.054L406.753 608.477L406.271 605.428Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M166.899 564.025L99.3176 574.704L91.0809 522.577L158.662 511.898L166.899 564.025ZM101.619 571.734L163.794 561.91L156.361 514.868L94.1858 524.692L101.619 571.734Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M130.45 556.035C137.565 554.91 142.475 548.574 141.418 541.882C140.36 535.189 133.736 530.676 126.621 531.8C119.506 532.924 114.596 539.26 115.654 545.953C116.711 552.645 123.336 557.159 130.45 556.035Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M332.274 137.124L43.8319 182.701L44.3136 185.75L332.755 140.172L332.274 137.124Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M335.645 158.463L47.2038 204.041L47.6855 207.089L336.127 161.512L335.645 158.463Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M339.017 179.803L50.5757 225.381L51.0574 228.429L339.499 182.852L339.017 179.803Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M99.6449 138.4L32.0637 149.079L23.8269 96.9518L91.4082 86.2731L99.6449 138.4ZM34.365 146.109L96.5398 136.285L89.1067 89.2431L26.9319 99.0674L34.365 146.109Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M63.1965 130.41C70.3111 129.285 75.2214 122.949 74.1639 116.257C73.1064 109.564 66.4817 105.051 59.3671 106.175C52.2525 107.299 47.3422 113.635 48.3997 120.328C49.4571 127.02 56.0819 131.534 63.1965 130.41Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M689.64 330.608L401.198 376.185L401.68 379.234L690.121 333.656L689.64 330.608Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M693.011 351.947L404.57 397.525L405.051 400.573L693.493 354.996L693.011 351.947Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M696.383 373.287L407.942 418.865L408.423 421.913L696.865 376.336L696.383 373.287Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M457.011 331.884L389.43 342.563L381.193 290.436L448.774 279.757L457.011 331.884ZM391.731 339.593L453.906 329.769L446.473 282.727L384.298 292.551L391.731 339.593Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M420.562 323.894C427.677 322.769 432.587 316.433 431.53 309.741C430.472 303.048 423.848 298.535 416.733 299.659C409.618 300.783 404.708 307.119 405.766 313.812C406.823 320.504 413.448 325.018 420.562 323.894Z",
    fill: "#6C63FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_2053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1403.6,
    height: 749.184,
    fill: "white",
    transform: "translate(-749 219.068) rotate(-8.97919)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawObservationsReOhja1);
export default __webpack_public_path__ + "static/media/undraw_observations_re_ohja 1.daef356f9811b1c15eef26d4da64bb1a.svg";
export { ForwardRef as ReactComponent };